export default "__VITE_ASSET__BaAxQH7K__"